<!-- 论文详情页 -->
<template>
  <div class="detail-box safe-distance-top-header safe-distance-bottom-tool">
    <Header
      :pageTitle="DetailsList.title ? $global.matchReg(DetailsList.title) : ''"
      :shareInfo="shareInfo"
    />
    <Shelves v-if="isShelves" />
    <div class="content-box" v-else>
      <!-- 顶部 -->
      <div class="info-box">
        <!-- 标题 -->
        <h1 class="title" v-html="DetailsList.title"></h1>
        <!-- 作者 -->
        <div class="public-item author-box" ref="author">
          <div class="public-title">作者</div>
          <span v-for="item in autherInfoList.authors" :key="item.id">
            <span
              v-if="item.id"
              class="author-item"
              @click="toBaijia(item.id)"
              >{{ item.name }}</span
            >
          </span>
          <!-- <span
            v-if="DetailsList.firstAuthor"
            class="author-item"
            @click="toBaijia(DetailsList.firstAuthorId)"
            >{{ DetailsList.firstAuthor }}</span
          >
          <span
            class="author-item"
            v-if="DetailsList.communicationAuthor"
            @click="toBaijia(DetailsList.communicationAuthorId)"
            >{{ DetailsList.communicationAuthor }}</span
          >
          <span
            class="author-item"
            v-for="(item, index) in DetailsList.articleAuthorList"
            :key="index"
            @click="toBaijia(item.authorId)"
            >{{ item.authorName }}</span
          > -->
        </div>
        <!-- 作者单位 -->
        <div class="public-item author-box" ref="unit">
          <div class="public-title">作者单位</div>
          <span v-for="item in autherInfoList.units" :key="item.id">
            <span class="author-item" @click="toDirectory(item.id)">{{
              item.name
            }}</span>
          </span>
          <!-- <span v-if="DetailsList.firstAuthorUnit" class="author-item">{{
            DetailsList.firstAuthorUnit
          }}</span>
          <span
            v-if="DetailsList.communicationAuthorUnit"
            class="author-item"
            >{{ DetailsList.communicationAuthorUnit }}</span
          >
          <span
            class="author-item"
            v-for="item in DetailsList.articleAuthorList"
            :key="item.authorId"
          >
            {{ item.authorUnit }}
          </span> -->
        </div>
        <!-- 摘要 -->
        <div v-if="DetailsList.artSummary" class="public-item" ref="abstract">
          <div class="public-title">摘要</div>
          <div
            class="public-text"
            v-html="$global.formatArtSumary(DetailsList.artSummary)"
          ></div>
        </div>
        <!-- 关键词 -->
        <div v-if="DetailsList.keyword" class="public-item">
          <div class="public-title">关键词</div>
          <div class="public-text">{{ DetailsList.keyword }}</div>
        </div>
        <!-- 论文集 -->
        <div v-if="DetailsList.proceedings" class="public-item">
          <div class="public-title">论文集</div>
          <div
            v-if="thesisCollect.bid"
            class="public-btn"
            @click="tocollectedPapers(thesisCollect.bid)"
          >
            {{ DetailsList.proceedings }}
          </div>
          <div v-else class="public-text">{{ DetailsList.proceedings }}</div>
        </div>
        <!-- 会议名称 -->
        <div v-if="DetailsList.mettingName" class="public-item">
          <div class="public-title">会议名称</div>
          <div
            v-if="thesisCollect.bid"
            class="public-btn"
            @click="
              toMeeting(
                thesisCollect.bid,
                thesisCollect.goodsId,
                thesisCollect.open
              )
            "
          >
            {{ DetailsList.mettingName }}
          </div>
          <div v-else class="public-text">{{ DetailsList.mettingName }}</div>
        </div>
        <!-- 会议时间 -->
        <div v-if="DetailsList.mettingTime" class="public-item">
          <div class="public-title">会议时间</div>
          <div class="public-text">
            {{ DetailsList.mettingTime.slice(0, 10) }}
          </div>
        </div>
        <!-- 会议地点 -->
        <div v-if="DetailsList.mettingAddress" class="public-item">
          <div class="public-title">会议地点</div>
          <div class="public-text">{{ DetailsList.mettingAddress }}</div>
        </div>

        <!-- 刊期 -->
        <div class="public-item" v-if="DetailsList.journalsYear">
          <div class="public-title">刊期</div>
          <div class="public-text">
            <span v-if="DetailsList.journalsYear"
              >{{ DetailsList.journalsYear }}年</span
            >
            <span v-if="DetailsList.journalsVolume"
              >第{{ DetailsList.journalsVolume }}卷</span
            >
            <span v-if="DetailsList.journalsTerm"
              >第{{ DetailsList.journalsTerm }}期</span
            >
          </div>
        </div>
        <!-- 栏目 -->
        <div v-if="DetailsList.articleColumn" class="public-item">
          <div class="public-title">栏目</div>
          <div class="public-text">{{ DetailsList.articleColumn }}</div>
        </div>
        <!-- 基金资助 -->
        <div v-if="DetailsList.fundStr" class="public-item">
          <div class="public-title">基金资助</div>
          <div class="public-text">{{ DetailsList.fundStr }}</div>
        </div>
        <!-- 数据库收录 -->
        <div v-if="DetailsList.dataStyle" class="public-item">
          <div class="public-title">数据库收录</div>
          <div class="public-text">{{ DetailsList.dataStyle }}</div>
        </div>
        <!-- 分类号 -->
        <div v-if="DetailsList.classifyNumber" class="public-item">
          <div class="public-title">分类号</div>
          <div class="public-text">{{ DetailsList.classifyNumber }}</div>
        </div>
        <!-- DOI -->
        <div v-if="DetailsList.doi" class="public-item">
          <div class="public-title">DOI</div>
          <div class="public-text">{{ DetailsList.doi }}</div>
        </div>
        <!-- 页数 -->
        <div v-if="DetailsList.pageNumber" class="public-item">
          <div class="public-title">页数</div>
          <div class="public-text">{{ DetailsList.pageNumber }}</div>
        </div>
        <!-- 页码 -->
        <div v-if="DetailsList.sizeNumber" class="public-item">
          <div class="public-title">页码</div>
          <div class="public-text">{{ DetailsList.sizeNumber }}</div>
        </div>

        <!-- 遮罩层 -->
        <!--<van-overlay :show="overlayShow" @click="cutOverlay(isPosition + 1)">
          <div class="overlay_box">
            <div class="overlay_content" ref="overlay_content">
              <div class="author" v-if="isPosition === 1">
                <div class="public-title">作者</div>
                <div class="public-text">
                  <div class="per-name">{{ DetailsList.firstAuthor }}</div>
                </div>
              </div>
               <div v-if="isPosition === 2">
                <div class="public-title">作者单位</div>
                <div class="public-text">
                  <div class="per_unit">{{ DetailsList.firstAuthorUnit }}</div>
                </div>
              </div>
              <div v-if="isPosition === 2" class="overlay_text">
                <div class="public-title">摘要</div>
                <div class="public-text overlay_text_box">
                  <p v-html="DetailsList.artSummary"></p>
                </div>
              </div>
              <div v-if="isPosition === 3">
                <div class="public-title">刊名</div>
                <div class="public-text">
                  <div class="per-name">{{ DetailsList.periodical }}</div>
                </div>
              </div>
              <div class="guide_box">
                <img
                  class="guide_line"
                  src="@/assets/img/details/line.png"
                  alt=""
                />
                <span class="guide_word" v-if="isPosition === 1"
                  >点击查看学者百家号</span
                >
                <span class="guide_word" v-if="isPosition === 2">点击进入机构名录详情</span>
                <span class="guide_word" v-if="isPosition === 2"
                  >长按选中，检索词语释义</span
                >
                <span class="guide_word" v-if="isPosition === 3"
                  >点击进入期刊详情</span
                >
              </div>
              <div
                class="close_btn"
                v-if="isPosition === 3"
                @click="closeOverlay"
              >
                我知道了
              </div>
            </div>
          </div>
        </van-overlay> -->
      </div>
      <div class="periodical-box" v-if="periodicalInfo.name">
        <div class="public-title">来源期刊</div>
        <div class="public-box" @click="toBaike(periodicalInfo.id)">
          <img
            class="periodical-img"
            :src="
              periodicalInfo.coverImg
                ? $global.imgUrl + periodicalInfo.coverImg
                : require('@/assets/img/mobile-img/image_error_ic.webp')
            "
            alt=""
          />
          <h1 class="periodical-name">{{ periodicalInfo.name }}</h1>
        </div>
      </div>
      <!-- 来源 -->
      <div
        class="periodical-box"
        v-if="thesisCollect.name && thesisCollect.collectType == 1"
      >
        <div class="public-title">来源</div>
        <div class="public-box" @click="tocollectedPapers(thesisCollect.bid)">
          <img
            class="periodical-img"
            :src="
              thesisCollect.cover
                ? $global.imgUrl + thesisCollect.cover
                : require('@/assets/img/mobile-img/image_error_ic.webp')
            "
            alt=""
          />
          <h1 class="periodical-name">{{ thesisCollect.name }}</h1>
        </div>
      </div>
      <div class="recommend-box" v-if="wenxian.length > 0">
        <div class="public-title">相似文献</div>
        <LvItem
          class="recommend-list-item"
          v-for="item in wenxian"
          :key="item.articleId"
          :title="item.title"
          :author="item.firstAuthor"
          :otherAuthor="
            item.communicationAuthor || item.othorAuthor ? ',...' : ''
          "
          :periodicalName="item.periodical"
          :periodicalTime="`${item.journalsYear}年第${item.journalsTerm}期`"
          @click.native="toDetail(item.articleId)"
        />
      </div>
    </div>
    <BottomTool
      v-if="!isShelves"
      :title="DetailsList.title"
      :artSummary="DetailsList.artSummary"
      :shareInfo="shareInfo"
    >
      <template #right>
        <OnlineReading />
      </template>
    </BottomTool>
  </div>
</template>

<script>
import Header from "./components/detailHeader.vue";
import BottomTool from "./components/bottomTool.vue";
import OnlineReading from "./components/OnlineReading.vue";
import LvItem from "@/views/mobileView/components/listItem/lvItem.vue";
import Shelves from "./components/shelves.vue";
export default {
  components: {
    Header,
    LvItem,
    Shelves,
    BottomTool,
    OnlineReading,
  },
  data() {
    //这里存放数据
    return {
      DetailsList: {},
      shareInfo: {},
      wenxian: [],
      isShelves: false,
      overlayShow: false,
      isPosition: 1,
      autherInfoList: {
        authors: [],
        units: [],
      },
      periodicalInfo: {},
      thesisCollect: {},
    };
  },
  //方法集合
  methods: {
    // 跳转会议
    toMeeting(id) {
      window.open(
        this.$global.meetingH5Url +
          `pagesModule/meetingDetails/index?type=8&id=${id}${
            this.$route.query.out ? "&out=" + this.$route.query.out : ""
          }`,
        "_self"
      );
    },
    // 跳转会议论文集
    tocollectedPapers(bid) {
      let out = this.$route.query.out;
      out
        ? this.$router.push(`conferenceProceedings?bid=${bid}&out=${out}`)
        : this.$router.push(`conferenceProceedings?bid=${bid}`);
    },
    // 作者跳百家
    toBaijia(id) {
      if (id == "") return;
      let out = this.$route.query.out;
      out
        ? this.$router.push(`appusesbaijia?item=0&id=${id}&out=${out}`)
        : this.$router.push(`appusesbaijia?item=0&id=${id}`);
    },
    // 刊名跳百科
    toBaike(id) {
      let out = this.$route.query.out;
      out
        ? this.$router.push(`appusesbaike?item=1&id=${id}&out=${out}`)
        : this.$router.push(`appusesbaike?item=1&id=${id}`);
    },
    // 跳转作者单位(名录详情页)
    toDirectory(id) {
      if (id) {
        let out = this.$route.query.out;
        out
          ? this.$router.push(
              `appusesinstitutions?type=2&orgId=${id}&out=${out}`
            )
          : this.$router.push(`appusesinstitutions?type=2&orgId=${id}`);
      }
    },
    // 获取详情页
    async getDetail() {
      let res = await this.$apis.recomendServe.getDetails({
        articleId: this.$route.query.id,
        articleType: this.$route.query.type,
      });
      if (res.resultCode === "200") {
        this.DetailsList = res.data.data;
        this.autherInfoList.authors = res.data.assembleAutherUnitInfo.authors;
        this.autherInfoList.units = res.data.assembleAutherUnitInfo.units;
        this.periodicalInfo = res.data.periodical || {};
        this.thesisCollect = res.data.thesisCollect || {};
        // 给APP分享需要的内容
        this.shareInfo = {
          title: this.DetailsList.title,
          artSummary: this.DetailsList.artSummary,
          articleId: this.$route.query.id,
          articleType: this.$route.query.type,
        };
        this.$global.toShare(
          this.DetailsList.title,
          this.DetailsList.artSummary
        );
        this.getwenxian();
      } else if (
        res.resultCode === "10401002" ||
        res.resultCode === "10401001"
      ) {
        this.isShelves = true;
      }
    },
    // 获取相似文献
    async getwenxian() {
      // console.log(this.detailsData.data);
      const { data } = await this.$apis.recomendServe.getwenxian({
        keyword: encodeURI(this.DetailsList.keyword),
        pageNo: 1,
        pageSize: 5,
        // title: "专著",
      });
      this.wenxian.push(...data.list);
    },
    // 相似文献跳转到详情
    toDetail(id) {
      let out = this.$route.query.out;
      out
        ? this.$router.push(`/thesisDetail?id=${id}&type=0&out=${out}`)
        : this.$router.push(`/thesisDetail?id=${id}&type=0`);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // if (this.$route.query.out) {
    //   if (this.$global.isAndroid_ios()) {
    //     window.android.getOverlay();
    //   } else {
    //     window.webkit.messageHandlers.getOverlay.postMessage("null"); //ios
    //   }
    //   // 接收APP传递的数据
    //   window.getOverlay = (data) => {
    //     if (this.$global.isAndroid_ios()) {
    //       this.overlayShow = data.body.value;
    //     } else {
    //       if (typeof data == "string") {
    //         this.overlayShow = JSON.parse(data).body.value;
    //       }
    //     }
    //   };
    // } else {
    //   this.overlayShow = !localStorage.getItem("hasOverlay");
    // }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getDetail();
  },
};
</script>
<style lang="scss" scoped>
.detail-box {
  padding-top: 56px;
  padding-bottom: 61px;
  background: #f5f5f5;
  min-height: 100vh;
  .content-box {
    padding: 0 12px;

    .public-item {
      margin-bottom: 25px;
    }
    .public-title {
      margin-bottom: 15px;
      font-size: 17px;
      font-weight: 700;
      color: #333333;
      line-height: 24px;
    }
    .public-btn {
      display: inline-block;
      padding: 6px 12px;
      background-color: #f5f5f5;
      border-radius: 15px;
    }
    .public-text {
      font-size: 14px;
      color: #333333;
      line-height: 24px;
      .per-name {
        padding: 0 8px;
        display: inline-block;
        border: 1px dashed #4585f5;
        border-radius: 5px;
        margin-right: 10px;
        font-size: 16px;
        color: #4459d3;
      }
      .per_unit {
        color: #4459d3;
      }
    }
    .info-box {
      padding: 16px 12px;
      width: 100%;
      background: #ffffff;
      border-radius: 8px;
      overflow: hidden;
      .title {
        margin-bottom: 25px;
        font-size: 17px;
        color: #333333;
        line-height: 24px;
        &::v-deep p {
          display: inline-block !important;
        }
      }
      .author-box {
        margin-bottom: 15px;
        .author-item {
          display: inline-block;
          margin-right: 15px;
          margin-bottom: 10px;
          padding: 6px 12px;
          background: #f5f5f5;
          border-radius: 15px;
          font-size: 13px;
          color: #333333;
          line-height: 19px;
        }
      }
      .logo {
        margin-top: 14px;
        display: flex;
        .left {
          margin-right: 10px;
        }
        .right {
          & .title {
            padding-top: 4px;
            font-size: 15px;
            font-family: PingFang;
            color: #333333;
            margin-top: 0px;
          }
          .time {
            padding-top: 4px;
            font-size: 10px;
            font-family: PingFang;
            font-weight: 500;
            color: #999999;
          }
        }
      }
      &::v-deep .van-overlay {
        z-index: 999;
        .overlay_box {
          display: flex;
          padding: 0 11px;
          height: 100%;
          .overlay_content {
            position: relative;
            // overflow: hidden;
            padding: 10px 5px;
            width: 100%;
            max-height: 20vh;
            border-radius: 10px;
            background-color: #fff;
            .guide_box {
              position: absolute;
              bottom: -50px;
              left: 60px;
              .guide_line {
                width: 93px;
                height: 34px;
              }
              .guide_word {
                font-size: 13px;
                color: #ffffff;
              }
            }
            .overlay_text {
              width: 100%;
              height: 100%;
              overflow: hidden;
              .overlay_text_box {
                width: 100%;
                // height: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
              }
            }
            .close_btn {
              position: absolute;
              bottom: -150px;
              left: 50%;
              margin-left: -63px;
              width: 126px;
              height: 40px;
              border: 1px solid #ffffff;
              border-radius: 10px;
              text-align: center;
              font-size: 13px;
              color: #ffffff;
              line-height: 40px;
            }
          }
        }
      }
    }
    .periodical-box {
      margin-top: 12px;
      padding: 13px 12px;
      width: 100%;
      background: #ffffff;
      border-radius: 8px;
      overflow: hidden;
      .public-box {
        display: flex;
        .periodical-img {
          flex: none;
          margin-right: 15px;
          width: 80px;
          height: 113px;
          border-radius: 4px;
        }
        .periodical-name {
          height: 100%;
          font-size: 15px;
          color: #000;
          overflow: hidden;
          display: -webkit-box;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2; //行数
          -webkit-box-orient: vertical;
        }
      }
    }
    .recommend-box {
      margin-top: 12px;
      padding: 13px 12px 0;
      width: 100%;
      background: #ffffff;
      border-radius: 8px;
      overflow: hidden;
      .recommend-list-item {
        border-bottom: 1px solid #eeeeee;
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
